import PropTypes from 'prop-types';

export const propTypes = {
  id: PropTypes.number,
  slug: PropTypes.string,
  title: PropTypes.string,
  code: PropTypes.string
};

export const defaultProps = {
  id: null,
  slug: null,
  title: null,
  code: null
};

export const mapPropTypes = {
  [PropTypes.number]: PropTypes.shape(propTypes)
};

export default { defaultProps, propTypes, mapPropTypes };
